define(['text!./templates/pa-quick-vehicle-info-state.html'], (template) => [() => ({
    restrict: 'A',
    template,
    scope: {
        model: '='
    }
})]);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/vehicle/directives/PAQuickVehicleInfoState.js
 **/